<template>
  <div id="concepts-detail">
    <header>
      <header-detail>
        <template v-slot:title>{{ concept.title }}</template>
        <template v-slot:client v-if="concept.client">{{ concept.client.title }}</template>
        {{ stripImageName(activeImage.name) }}
      </header-detail>
    </header>

    <div class="concept-thumbs">
      <div class="thumb" v-for="image in concept.concepts" :key="image.id" :id="`thumb-${image.id}`">
        <div class="image"><img class="lazyload" data-sizes="auto" :data-src="`${image.url}?w=500&h=400&mode=crop&anchor=topleft`" /></div>
        <div class="title">{{ stripImageName(image.name) }}</div>
      </div>
    </div>
    
    <div class="canvas">
      <section class="concept-slider">
        <div class="image" v-for="image in concept.concepts" :key="image.id">
          <a :href="`${image.url}?w=1600`"  class="lightbox-link"></a>
          <img 
            class="lazyload" 
            :data-src="image.url"
            @load="onImgLoad($event, image.name)"
          />
          <span class="loader"></span>          
        </div>
      </section>
      <div class="slider-arrows">
      </div>
    </div>
  </div>
</template>

<script>
import conceptsService from "@/services/conceptsService";
import HeaderDetail from '@/components/HeaderDetail.vue';
// import GLightbox from "glightbox";
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

export default {
  name: "ConceptListView",

  components: {
    HeaderDetail
  },

  data() {
    return {
      concept: {},
      activeImageIndex: 0,
      lightbox: undefined,
      loading: false,
      initialized: false,
    };
  },

  computed: {
    id() {
      return this.$route.params["id"];
    },
    activeImage() {
      if (this.activeImageIndex >= 0 && this.concept.concepts?.length > this.activeImageIndex) {
        return this.concept.concepts[this.activeImageIndex];
      }
      return {};
    }
  },

  methods: {
    async bindConcepts() {
      this.concept = await conceptsService.getConcept(this.id);
    },
    initSlick() {
      const $this = this;
      $(".concept-slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        autoplay: false,
        appendArrows: $('.slider-arrows'),
        asNavFor: '.concept-thumbs'
      })
      .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        // console.log('slick beforeChange', slick, currentSlide, nextSlide);
        $this.activeImageIndex = nextSlide;
        
        const adaptiveHeight = slick.options.adaptiveHeight;
        if (!adaptiveHeight) {
          $(this).slick('slickSetOption','adaptiveHeight', true, true);
        }
      });

      $(".concept-thumbs").slick({
        slidesToShow: 20,
        slidesToScroll: 1,
        infinite: false,
        asNavFor: '.concept-slider',
        dots: false,
        arrow: false,
        focusOnSelect: true
      });
    },
    isImageRetina(name) {
      return !name?.endsWith('-1x');
    },
    stripImageName(name) {
      const nameWithoutExtension = name?.replace(/\.[^/.]+$/, '') // remove file extension, e.g. .jpg, .png, .webp
      if (!this.isImageRetina(nameWithoutExtension)) {
        return nameWithoutExtension.slice(0, -3);
      }
      return nameWithoutExtension;
    },
    onImgLoad(e, imageName) {
      let styleWidth;
      if (this.isImageRetina(imageName)) {
        styleWidth = `${e.target.naturalWidth / 2}px`;
      } else {
        styleWidth = `${e.target.naturalWidth}px`;
      }
      console.log('onImgLoad imageName, naturalWidth, style.width', imageName, e.target.naturalWidth, styleWidth);
      e.target.style.width = styleWidth;

      let parent = e.target.parentElement;
      let anchor = parent.querySelector('.lightbox-link');
      if (anchor) {
        anchor.setAttribute('data-pswp-width', e.target.naturalWidth);
        anchor.setAttribute('data-pswp-height', e.target.naturalHeight);
      }

    }
  },

  async mounted() {
    this.loading = true;    
    await this.bindConcepts();
    this.$nextTick(() => {
      this.initSlick();
      // this.lightbox = GLightbox({
      //   zoomable: false
      // });
      
      this.lightbox = new PhotoSwipeLightbox({
        gallery: '.concept-slider',
        children: 'a',
        pswpModule: () => import('photoswipe')
      });
      this.lightbox.init();      

      this.loading = false;
      this.initialized = true;
    });
  }

}
</script>
